/**
 * LoveLab cart packshot — always save the jewelry photo (selected cord color),
 * never 2nd/3rd gallery model/lifestyle tiles.
 *
 * Separate file so it still runs if an old product-form.js is cached
 * (customElements.define('product-form') cannot be replaced).
 */
(function () {
  function basename(url) {
    try {
      const path = new URL(url, window.location.origin).pathname;
      return decodeURIComponent(path.split('/').pop() || '').toLowerCase();
    } catch (e) {
      const raw = String(url || '').split('?')[0];
      return decodeURIComponent(raw.split('/').pop() || '').toLowerCase();
    }
  }

  function isLifestyle(url) {
    const file = basename(url);
    if (!file) return false;
    if (/lifestyle|banner/.test(file)) return true;
    if (/^classy_heart/.test(file)) return true;
    return /^(sparkle_round|shapy_sparkle_round_2|round_sparkle|pear_sparkle|oval_sparkle|sparkle_heart|sparkle_oval|sparkle_emerald|sparkle_marq|princesse_sparkle|longcushion_sparkle|shine_heart|shine_pear|shine_bezel_heart|shine_oval|shapyshine|shapy_pear_marq|emerald_rotate|marq_shine|oval_shine|longcushion_shine|matchy_heart\.png|matchy_pear\.png|matchy_emerald\.jpg|matchy_pear_bezel|necklace_banner|three_white|three_pink|three_yellow|three_mix|triplymix|holy_lifestyle|cubix\.jpeg|cubix_2)/.test(
      file
    );
  }

  function toPublicUrl(url) {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      const isLocal =
        parsed.hostname === '127.0.0.1' ||
        parsed.hostname === 'localhost' ||
        parsed.port === '9292';
      if (!isLocal) return parsed.href;
      if (parsed.pathname.startsWith('/cdn/')) {
        return 'https://cdn.shopify.com' + parsed.pathname.replace(/^\/cdn/, '') + parsed.search;
      }
      if (window.Shopify && Shopify.shop) {
        return 'https://' + Shopify.shop + parsed.pathname + parsed.search;
      }
      return parsed.href;
    } catch (e) {
      return url;
    }
  }

  function packshotUrl() {
    const packshot = document.getElementById('ll-cuty-packshot-image');
    if (packshot) {
      const packUrl = (packshot.currentSrc || packshot.src || '').trim();
      if (packUrl && !packUrl.startsWith('data:')) return toPublicUrl(packUrl);
    }
    const img =
      document.getElementById('ll-cuty-main-image') ||
      document.getElementById('ll-cubix-main-image') ||
      document.querySelector('[data-ll-cart-photo]');
    if (!img) return '';
    const url = (img.currentSrc || img.src || '').trim();
    if (!url || url.startsWith('data:')) return '';
    if (isLifestyle(url)) return '';
    return toPublicUrl(url);
  }

  function writeHidden(form, url) {
    if (!form || !url) return;
    let hidden = form.querySelector('[data-ll-cart-image], input[name="properties[_ll_image]"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[_ll_image]';
      hidden.setAttribute('data-ll-cart-image', '');
      form.appendChild(hidden);
    }
    hidden.value = url;
  }

  function syncAll() {
    const url = packshotUrl();
    if (!url) return;
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(function (form) {
      writeHidden(form, url);
    });
  }

  function applyToFormData(body) {
    const url = packshotUrl();
    if (!url || !body) return;
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      body.set('properties[_ll_image]', url);
    }
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var href = typeof input === 'string' ? input : input && input.url;
        if (href && /\/cart\/add/.test(href) && init && init.body) {
          applyToFormData(init.body);
        }
      } catch (e) {}
      return origFetch.apply(this, arguments);
    };
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-form').then(function () {
      var Ctor = customElements.get('product-form');
      if (!Ctor || !Ctor.prototype) return;
      var orig = Ctor.prototype.syncCartImageProperty;
      Ctor.prototype.syncCartImageProperty = function (formData) {
        var url = packshotUrl();
        if (url) {
          writeHidden(this.form, url);
          if (formData && typeof formData.set === 'function') {
            formData.set('properties[_ll_image]', url);
          }
          return;
        }
        if (typeof orig === 'function') orig.call(this, formData);
      };
    });
  }

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (!form || !form.getAttribute) return;
      if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
      const url = packshotUrl();
      if (url) writeHidden(form, url);
    },
    true
  );

  function watchMainImage() {
    const img =
      document.getElementById('ll-cuty-main-image') ||
      document.getElementById('ll-cubix-main-image') ||
      document.querySelector('[data-ll-cart-photo]');
    if (!img || img.dataset.llPackshotWatch === '1') return;
    img.dataset.llPackshotWatch = '1';
    syncAll();
    new MutationObserver(syncAll).observe(img, {
      attributes: true,
      attributeFilter: ['src', 'srcset'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchMainImage);
  } else {
    watchMainImage();
  }
  document.addEventListener('change', function () {
    setTimeout(syncAll, 50);
  });
})();
